'use client';

import { FC, useRef, useState } from 'react';
import { Container, ControlsBox, StaticGrid, StyledButton } from './styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation } from 'swiper/modules';
import { HousingCard } from '@/components';
import { IHousingObjectResponse } from '@/types';
import { SwiperArrowLeft, SwiperArrowRight } from '@/components';

type CarouselProps = {
  data?: IHousingObjectResponse[];
  isProject?: boolean;
};

export const Carousel: FC<CarouselProps> = ({ data, isProject }) => {
  const swiperRef = useRef<SwiperType>(null);

  const [IsEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const handleSlideChange = (swiper: SwiperType) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <Container>
      <ControlsBox>
        <StyledButton
          variant="outlined"
          disabled={isBeginning}
          onClick={() => swiperRef.current?.slidePrev()}
          aria-label="Previous slide"
        >
          <SwiperArrowLeft aria-hidden="true" />
        </StyledButton>
        <StyledButton
          variant="outlined"
          disabled={IsEnd}
          onClick={() => swiperRef.current?.slideNext()}
          aria-label="Next slide"
        >
          <SwiperArrowRight aria-hidden="true" />
        </StyledButton>
      </ControlsBox>

      {!initialized && (
        <StaticGrid aria-hidden="true">
          {data?.slice(0, 3).map((e, i) => (
            <HousingCard key={i} data={e} isProject={isProject ?? false} />
          ))}
        </StaticGrid>
      )}

      <div
        style={
          initialized
            ? undefined
            : { position: 'absolute', opacity: 0, pointerEvents: 'none', width: '100%' }
        }
      >
        <Swiper
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
            handleSlideChange(swiper);
          }}
          onSwiper={() => setInitialized(true)}
          onSlideChange={handleSlideChange}
          modules={[Navigation]}
          initialSlide={0}
          className="mySwiper"
          spaceBetween={24}
          breakpoints={{
            960: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            800: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
          }}
        >
          {data?.map((e, i) => (
            <SwiperSlide
              key={i}
              style={{ height: 'auto', paddingBottom: '2px' }}
              aria-label={`Slide ${i + 1}`}
            >
              <HousingCard data={e} isProject={isProject ?? false} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Container>
  );
};
